<script setup lang="ts">
defineProps({
  href: { type: String, default: '' },
  title: { type: String, required: true },
  back: { type: Boolean, default: false }
})

defineEmits(['handleClick'])
</script>

<template>
  <NuxtLink v-if="href !== ''" :class="`arrow-link ${back ? 'arrow-link-back' : ''}`" :to="href">
    <span>
      {{ title }}
    </span>

    <CommonIconArrow />
  </NuxtLink>

  <div
    v-else
    :class="`arrow-link clickable ${back ? 'arrow-link-back' : ''}`"
    @click="$emit('handleClick')"
  >
    <span>
      {{ title }}
    </span>

    <CommonIconArrow />
  </div>
</template>

<style scoped lang="scss">
.arrow-link {
  display: inline-flex;
  align-items: center;
  gap: 10px;

  span {
    color: var(--purple);
    font-weight: 500;
    font-size: 0.95rem;
    line-height: 1.4rem;
    transition: color 0.3s ease-out;
  }

  svg {
    $size: 13px;
    height: $size;
    width: $size;
    fill: var(--purple);
    transition:
      fill 0.3s ease-out,
      transform 0.3s ease-out;
  }

  &-back {
    flex-direction: row-reverse;

    svg {
      transform: scaleX(-1);
    }
  }
}

@media (hover: hover) {
  .arrow-link:hover {
    span {
      color: var(--black);
    }

    svg {
      fill: var(--black);
      transform: translateX(5px);
    }
  }

  .arrow-link-back:hover {
    svg {
      transform: scaleX(-1) translateX(5px);
    }
  }
}
</style>
